
import { defineComponent } from 'vue'

export default defineComponent({
    name: "CursorBlob",

    data(){
        return{

            // Settings
            cursorBlobSize: 48,     // width in px

            // Code
            cursorBlob: null as null | HTMLElement,
            mobilePage: false,
            wasCursorMoved: false,
            halfBlobSize: 0
        }
    },

    mounted(){

        // Cursor Blob
        this.cursorBlob = this.$refs.cursorBlob as HTMLElement;
        this.cursorBlob.style.width = `${this.cursorBlobSize}px`;

        // Set the blob's half-size
        this.halfBlobSize = this.cursorBlobSize / 2;

        // check the page size (mobile/desktop)
        this.checkIfMobile;
        window.addEventListener("resize", this.checkIfMobile);

        // Cursor blob position
        window.addEventListener("mousemove", this.cursorBlobPos);

        // Check if the cursor is outside the page
        document.body.addEventListener("mouseleave", this.outOfBounds);

    },

    methods:{

        checkIfMobile(){

            if (window.innerWidth <= 768){
                this.mobilePage = true;
                this.wasCursorMoved = false;
            } else {
                this.mobilePage = false;
            }

        },

        outOfBounds(){

            this.cursorBlob!.classList.remove("cursor-blob-visible");
            this.wasCursorMoved = false;

        },

        cursorBlobPos(e: MouseEvent){

            if (this.mobilePage) return;

            // Set the blob position
            requestAnimationFrame(() => {
                this.cursorBlob!.style.transform =
                    `translate3d(
                        ${e.clientX - this.halfBlobSize}px, 
                        ${e.clientY - this.halfBlobSize}px, 
                        0px)
                    `;
            });

            // Show the blob
            if (!this.wasCursorMoved){
                this.wasCursorMoved = true;
                this.cursorBlob!.classList.add("cursor-blob-visible");
            }

        }
        
    }

});
